module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "u7mwalYPM8rshzavJiRlDEB"
    }
  }, [_vm._v("Chapter Nine")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_vm._v("The room was white, bleached, colorless. The mattress on the bed, hard. “I must be in hell,” Tilden groaned"), _c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v(". What’s with the plastic tube taped to my hand?")]), _vm._v(" "), _c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("Is that Juicy Juice in the hanging bag attached to the tube?")]), _vm._v(" As a child, his mother only bought Juicy Juice, fake orange juice. Tilden felt a wave of nausea. "), _c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("Who was this Asian man approaching?")]), _vm._v(" “Who are you?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“I am Doctor Yang Lee, trauma surgeon. How are you feeling?” the physician asked, palpating his Tilden’s hand.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Doctor Lee was a thin man. Ralph Lauren glasses framed his artificially tanned face, accented by a thin mustache. Fastened to his avocado green tie was a Tiffany gold crucifix.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Where am I?” Tilden stuttered.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Saint Clara’s Hospital. You feeling any pain?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Who are you?” Tilden asked again. He glared suspiciously at the crucifix on his tie.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“I’m Doctor Yang Lee,” he repeated, checking the medication chart clipped to Tilden’s bed frame. Turning to the man standing beside him wearing an oversized cotton cap to cover his mane of braided hair, he said: “Robinson, we’re going to increase the anodyne.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“What’s that?” Tilden asked, anguish in his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“It’ll help with the pain,” the man explained.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“And who are you?” Tilden asked, sizing up the lanky black man who looked like Bob Marley.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“I’m your nurse.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“If you say so,” Tilden replied.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Did they bring you breakfast this morning, Mr. Quinn?” the nurse asked, revealing a Jamaican accent.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“No. And I’m hungry as hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“I’ll check with the nutritionist and see what she can come up with,” he said before leaving the room.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Do you know where you are?” Doctor Lee asked Tilden.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Tilden panoramically scanned the room. “It looks like a hospital room to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Do you know why you’re here?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“An EMT crew brought you in yesterday morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“What happened to me? Was I in a car accident?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“No. They found you in a hotel room.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Tilden shot the physician a look of disbelief. “No way,” he muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Looks like you were mistreated.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Tilden studied the doctor’s face. "), _c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("Was this reality or was he dreaming?")]), _vm._v(" he wondered. “Mistreated how?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“You were hurt pretty badly.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("A look of skepticism filled Tilden’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“How about we talk about it after you’ve had something to eat,” the surgeon suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“No, I gotta know now.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“You were… violated.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The doctor paused. “You were sodomized,” he told him.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The color drained from Tilden’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“And, like I said a moment ago, you were hurt pretty badly.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“But I don’t feel any pain,” Tilden said.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“That’s because of all the analgesics you’re on.” He pointed to the hanging IV bag.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Who did that to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“I don’t know. The police are reviewing the hotel’s security cameras.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“I don’t remember a thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Doctor Lee hesitated, growing silent as was his custom before delivering the news no patient wanted to hear. “You’ll be needing surgery, Mr. Quinn.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Surgery? For what?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“You were severely ripped up.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Please tell me you’re kidding.” Tilden’s chin quivered as he began to sob.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“I’m a damn good surgeon. You’ll be in good care.” Doctor Lee placed his hand over Tilden’s. “I have a few more questions. Ok to ask them now?")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Tilden nodded as he wiped tears from his face.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“What do you do for a living?” the surgeon asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“I’m retired from the funeral business. You’re gonna cut me up, right?” Tilden asked, his face awash with fright.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Well, your large intestine’s been torn. In fact, it’s in tatters. It will require repair and many sutures. You’ll likely be wearing a colostomy bag for awhile.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Oh, my God! I’ll be a walking toilet.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“I won’t know for sure until I perform the surgery.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Oh, my God!” Tilden repeated, his eyes widening.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d29c470","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chap_09.vue
// module id = 102
// module chunks = 0